import {useAccess} from "./access/useAccess";
import {
  useState,
  lazy,
  Suspense
} from "react";

const BoltonPanel =
  lazy(() =>
    import("./BoltonPanel")
  );

const CefalometriaPanel =
  lazy(() =>
    import("./CefalometriaPanel")
  );

const STLPanel =
  lazy(() =>
    import("./STLPanel")
  );

const baseTabStyle = {

  flex: "1 1 0",

  minWidth: 0,

  width: "100%",

  minHeight: 46,

  padding: "11px 10px",

  borderRadius: 14,

  border: "1px solid transparent",

  cursor: "pointer",

  fontWeight: 700,

  transition:
    "background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease",

  fontSize: 13,

  lineHeight: 1.2,

  display: "flex",

  alignItems: "center",

  justifyContent: "center",

  textAlign: "center",

  boxSizing: "border-box",

  whiteSpace: "normal",

  overflow: "hidden"

};

export default function OrtodonciaPanel({
  pacienteId,
  clinicId
}) {

  const {can}=useAccess();
  const permitted={cefalo:can("ceph"),bolton:can("bolton"),stl:can("stl")};
  const [
    subTab,
    setSubTab
  ] = useState("cefalo");

  const tabStyle =
    (active) => ({

      ...baseTabStyle,

      background:
        active
          ? "#2563eb"
          : "#f1f5f9",

      color:
        active
          ? "#ffffff"
          : "#334155",

      borderColor:
        active
          ? "#2563eb"
          : "#e2e8f0",

      boxShadow:
        active
          ? "0 6px 16px rgba(37,99,235,0.20)"
          : "none",

      transform:
        active
          ? "translateY(-1px)"
          : "translateY(0)"

    });

  const renderPanel = () => {

    if(!permitted[subTab])return <p>Selecciona un estudio autorizado para tu usuario.</p>;
    switch(subTab) {

      case "cefalo":

        return (

          <CefalometriaPanel
            pacienteId={pacienteId}
            clinicId={clinicId}
          />

        );

      case "bolton":

        return (

          <BoltonPanel
            key={`${clinicId}:${pacienteId}`}
            pacienteId={pacienteId}
            clinicId={clinicId}
          />

        );

      case "stl":

        return (

          <STLPanel
            pacienteId={pacienteId}
            clinicId={clinicId}
          />

        );

      default:

        return null;
    }
  };

  return (

    <div
      style={{

        width: "100%",

        maxWidth: "100%",

        minWidth: 0,

        boxSizing: "border-box",

        overflow: "hidden",

        display: "flex",

        flexDirection: "column",

        gap: 16

      }}
    >

      {/* =========================
          NAVEGACIÓN ORTODONCIA
      ========================= */}

      <div
        style={{

          width: "100%",

          maxWidth: "100%",

          minWidth: 0,

          boxSizing: "border-box",

          padding: 5,

          borderRadius: 18,

          background: "#eaf0f8",

          display: "flex",

          gap: 6,

          alignItems: "stretch",

          overflow: "hidden"

        }}
      >

        <button
          type="button"

          disabled={!permitted.cefalo}
          onClick={() =>
            setSubTab("cefalo")
          }

          style={tabStyle(
            subTab === "cefalo"
          )}
        >

          Cefalometría

        </button>

        <button
          type="button"

          disabled={!permitted.bolton}
          onClick={() =>
            setSubTab("bolton")
          }

          style={tabStyle(
            subTab === "bolton"
          )}
        >

          Análisis de Bolton

        </button>

        <button
          type="button"

          disabled={!permitted.stl}
          onClick={() =>
            setSubTab("stl")
          }

          style={tabStyle(
            subTab === "stl"
          )}
        >

          Modelos STL

        </button>

      </div>

      {/* =========================
          CONTENIDO
      ========================= */}

      <div
        style={{

          width: "100%",

          maxWidth: "100%",

          minWidth: 0,

          boxSizing: "border-box",

          overflow: "hidden",

          paddingBottom: 24

        }}
      >

        <Suspense
          fallback={

            <div
              style={{

                width: "100%",

                boxSizing: "border-box",

                padding: 28,

                borderRadius: 18,

                background: "#ffffff",

                border:
                  "1px solid #e2e8f0",

                textAlign: "center",

                color: "#64748b",

                fontSize: 14,

                fontWeight: 600

              }}
            >

              Cargando módulo...

            </div>

          }
        >

          {renderPanel()}

        </Suspense>

      </div>

    </div>

  );
}
